import { render, staticRenderFns } from "./new-contact-customer.vue?vue&type=template&id=0f067693&scoped=true&"
import script from "./new-contact-customer.vue?vue&type=script&lang=js&"
export * from "./new-contact-customer.vue?vue&type=script&lang=js&"
import style0 from "./new-contact-customer.vue?vue&type=style&index=0&id=0f067693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f067693",
  null
  
)

export default component.exports